import $ from 'jquery';
import SweetScroll from 'sweet-scroll';
import lazySizes from 'lazysizes';

var path = location.pathname.split('/');

document.addEventListener('DOMContentLoaded', () => {
  const isMobile = window.matchMedia('(max-width:767px)').matches;

  $('[data-bg]').each(function () {
    const bgImg = $(this).data('bg');
    $(this).removeClass('img-loader');
    $(this).addClass('img-loaded');
    $(this).css('background-image', 'url(' + bgImg + ')');
  });

  // #priceへのスクロールのみ180px下に調整するため、事前にdata-scroll属性を削除
  let $priceLinks = $('a[href="#price"][data-scroll], a[href*="#price"][data-scroll]');
  $priceLinks.removeAttr('data-scroll');

  // ページ内リンクなどのスムーススクロール
  let SweetOffset = 0;
  if (isMobile) {
    SweetOffset = ($('.header__top').height() * 1.5) * -1;
  }
  if ($('.sticky').length) {
    SweetOffset -= $('.sticky').height();
  }
  const scroller = new SweetScroll({
    offset: SweetOffset,
  });

  // ロード時にハッシュがついていたらスクロールする
  const hash = window.location.hash;
  const needsInitialScroll = document.getElementById(hash.substr(1)) != null;
  if (needsInitialScroll) {
    window.location.hash = '';
  }
  window.addEventListener(
    'load',
    () => {
      if (needsInitialScroll) {
        scroller.to(hash, {
          updateURL: 'replace'
        });
      }
    },
    false,
  );

  // ページ内リンク用にhrefを置換
  $('[data-scroll]').each(function () {
    const href = $(this).attr('href');
    if (!href.startsWith('#')) {
      // hrefが#から始まっていなければハッシュを取得
      const split = href.split('#');
      if (split[0] === location.pathname) {
        // ページ内リンクならハッシュのみに置換
        $(this).attr('href', '#' + split[1]);
      } else {
        // 他ページへのリンクなら属性を削除
        $(this).removeAttr('data-scroll');
      }
    }
  });

  // #priceへのスクロールのみ180px下に調整
  // hrefの置換処理の後にもう一度#priceリンクを検索してカスタムイベントハンドラを設定
  $priceLinks = $('a[href="#price"]').not('[data-scroll]');
  $priceLinks.off('click').on('click', function (e) {
    e.preventDefault();
    scroller.to('#price', {
      offset: SweetOffset + 180,
      updateURL: false
    });
  });

  // ロード時点で現在地に.activeを付与
  $('.js-current').each(function () {
    let isActive = false,
      $this = $(this);
    var href = $this.attr('href').split('/');
    if (!$this.attr('href')) {
      isActive = false;
    } else if (href[href.length - 2] === path[path.length - 2]) {
      // リンク先と現在のURLのn個めのディレクトリ名が同一であればactiveにする
      isActive = true;
    } else if (href[href.length - 2] === path[path.length - 3]) {
      isActive = true;
    } else if (href[href.length - 2] === path[path.length - 4]) {
      isActive = true;
    }

    if (isActive) {
      $this.addClass('current');
      if ($this.closest('.js-current-group').length) {
        $this.closest('.js-current-group').addClass('active');
      }
    }
  });

  $(".js-current-child").each(function () {
    let isActive = false,
      $this = $(this);
    var href = $this.attr("href").split("/");
    if (!$this.attr("href")) {
      isActive = false;
    } else if (href[href.length - 2] === path[path.length - 2]) {
      // リンク先と現在のURLのn個めのディレクトリ名が同一であればactiveにする
      isActive = true;
    }

    if (isActive) {
      $this.addClass("current");
    }
  });

  $('[data-toggle]').on('click', function (e) {
    e.preventDefault();
    const $this = $(this);
    $this.toggleClass('active');
    $($this.attr('data-toggle')).toggleClass('active');
  });

  $('.js-change-page').change(function () {
    const $this = $(this);
    if ($this.val()) {
      location.href = $this.val();
    }
  });

  lazySizes.init();
  document.addEventListener('lazybeforeunveil', function (e) {
    var bg = e.target.getAttribute('data-bg');
    if (bg) {
      e.target.style.backgroundImage = 'url(' + bg + ')';
    }
  });

  // startWith polyfill
  if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
      position = position || 0;
      return this.indexOf(searchString, position) === position;
    };
  }


  /**
   * stick toggle class on trigger
   */
  // get the sticky element
  const stickyElm = document.querySelectorAll('.sticky');

  if (stickyElm.length) {
    for (let i = 0; i < stickyElm.length; i++) {

      const observer = new IntersectionObserver(
        ([e]) => e.target.classList.toggle('is-sticky', e.intersectionRatio < 1), {
          threshold: [1]
        }
      );
      observer.POLL_INTERVAL = 100;
      observer.observe(stickyElm[i]);

    }
  }
}, false);